export default __webpack_public_path__ + "static/speed-gauge-03-or-eb9291c836aabd27cf1c800ebd99de29.png";